module.exports = __webpack_public_path__ + "img/P35-zh.0ab84e12.png";